import { API } from "../utils/constants";
import { constructURL } from "../utils/util";
import { getAuthHeaders } from "./api-service";

type AdminServiceParams = {
    bodyParams?: any;
    urlParams?: string;
    method?: 'GET' | 'PUT' | 'POST' | 'DELETE';
    withUserId?: boolean;
    isFormData?: boolean;
    controller?: AbortController | null | undefined
}

export const adminService = async ({ urlParams, bodyParams, method = 'POST', isFormData = false, controller }: AdminServiceParams): Promise<any> => {
    let URL = urlParams ? `${API.ADMIN_BASE_URL}/${urlParams}` : API.ADMIN_BASE_URL;
    URL = constructURL(URL, bodyParams?.apiId ? bodyParams?.apiId : '', true);
    const headers: Record<string, string> = getAuthHeaders();

    if (isFormData) {
        delete headers['Content-Type'];
    }

    const response = await fetch(URL, {
        method: method,
        body: isFormData ? bodyParams : JSON.stringify(bodyParams),
        headers,
        signal: controller?.signal || null
    });
    if (response.status >= 500) {
        throw new Error('Something went wrong. Please try again later.');
    }
    return response.json();
}
